module.exports = __webpack_public_path__ + "img/logo-ubaya.baaef876.png";